import React, { useState } from "react";
import {
  ShoppingCart,
  CheckCircle,
  Sparkles,
  Lock,
  Gift,
  Crown,
} from "lucide-react";
import CheckoutModal from "./CheckoutModal";
import CurrencyConverter from "../../Currency/CurrencyConverter";
import { useSelector } from "react-redux";
import { ApiHook } from "../../hooks/apiHook";

const XionMbBox = ({ productData }) => {
  const [hasPurchased, setHasPurchased] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const addCartMutation = ApiHook.CallAddToCart();
  const currency = useSelector((state) => state.user?.selectedCurrency);
  const conversionFactor = useSelector((state) => state.user?.conversionFactor);

  const handleOpenCheckout = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    const data = {
        packageId: productData.id,
     };
    addCartMutation.mutate(data, {
        onSuccess: (res) => {
          setIsOpen(true)
        },
    });
  }

  let totalAmount;

  if (productData) {
    totalAmount = productData.price + productData.fee;
    productData.currency = currency?.symbolLeft ? currency?.symbolLeft : "$";
  }
  if (!productData) {
    return null;
  }

  return (
    <div className="kyc-container">
      <div className="xion-card">
        <div className="card-pattern"></div>
        <div className="card-header">
          <div className="product-info">
            <div className="product-badge">
              <Crown size={12} />
              <span>PREMIUM</span>
            </div>
            <h2 className="product-title">{productData.name}</h2>
          </div>

          <div className="status-icon">
            {hasPurchased && <CheckCircle className="icon-owned" size={24} />}
          </div>
        </div>

        <div className="card-content">
          {hasPurchased ? (
            // Owned State
            <div className="owned-state">
              <div className="owned-content">
                <h3 className="owned-title">Owned</h3>
                <p className="owned-description">
                  XION MB successfully acquired
                </p>

                <div className="status-grid">
                  <div className="status-item">
                    <Gift size={14} />
                    <div className="status-text">
                      <span className="status-value">
                        {productData.currency}{" "}
                        {CurrencyConverter(productData.price, conversionFactor)}
                      </span>
                      <span className="status-label">Bonus</span>
                    </div>
                  </div>

                  <div className="status-item">
                    <Sparkles size={14} />
                    <div className="status-text">
                      <span className="status-value">Active</span>
                      <span className="status-label">Status</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            // Purchase State
            <div className="purchase-state">
              <div className="pricing-section">
                <div className="price-row">
                  <span className="price-label">Price</span>
                  <span className="price-value">
                    {productData.currency}{" "}
                    {CurrencyConverter(productData.price, conversionFactor)}
                  </span>
                </div>
                <div className="price-row">
                  <span className="price-label">Processing Fee</span>
                  <span className="price-value">
                    {productData.currency}{" "}
                    {CurrencyConverter(productData.fee, conversionFactor)}
                  </span>
                </div>
                <div className="price-row price-row-total">
                  <span className="price-label">Total Price</span>
                  <span className="price-value-total">
                    {productData.currency}{" "}
                    {CurrencyConverter(totalAmount, conversionFactor)}
                  </span>
                </div>
              </div>

              <div className="benefits-row">
                <div className="benefit-item">
                  <Gift size={16} />
                  <span>
                    {productData.xionInviterAmount} {productData.currency}{" "}
                    direct bonus to inviter
                  </span>
                </div>
                <div className="benefit-item">
                  <Crown size={16} />
                  <span>Exclusive to registered users</span>
                </div>
              </div>

              <button
                className="purchase-button"
                onClick={handleOpenCheckout}
              >
                <ShoppingCart size={16} />
                <span>Buy Now</span>
              </button>
            </div>
          )}
        </div>
      </div>
      {isOpen && (
        <CheckoutModal product={"xion"} isOpen={isOpen} setIsOpen={setIsOpen} />
      )}
    </div>
  );
};

export default XionMbBox;
